<form>
  <mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ 'FINAL_BALANCER.SEARCH' | translate }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input type="text" matInput [formControl]="searchInput" />
  </mat-form-field>
</form>
